import { useMutation } from '@tanstack/react-query';
import { getApiUrl, handleFetchResponse } from '../shared/utils/api';

export function useValidateVoucher({ token }) {
  const mutation = useMutation({
    mutationKey: ['validate-voucher', token],
    mutationFn: async (params) => {
      const data = await handleFetchResponse(
        fetch(getApiUrl(`energia-solar/v2/validate-voucher/${params.voucher}`), {
          method: 'POST',
          body: '{}',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }),
      );
      return data;
    },
  });

  return mutation;
}
